import initialLabels from "assets/data/initialLabels.data";
import utils from "../utils/utils";
import moment from "moment";

/**
 * Label Service - Resolve labens from Cooperforte WordPress Label Service
 */
const labelService = ($rootScope, $http) => {
	"ngInject";

	//let labels = localStorage.getItem("cachedLabels") ? JSON.parse(localStorage.getItem("cachedLabels")) : initialLabels;

	let labels = initialLabels;

	/**
	 * Init Label Service, try to load labels from cache, otherwise go to WordPress Service
	 */
	const init = () => {
		/*let lastUpdate = localStorage.getItem("lastUpdateLabels") || "2017-11-01";
		let cooperforteLabelServiceUrl = `http://www.cooperforte.coop.br/mobile-xml-v3?date_filter=${lastUpdate}`;

		//Hit WP Label service
		$http({method: 'GET', url: cooperforteLabelServiceUrl})
			.then((res) => {
				if (utils.jsonHasPath(res, "data.mobileBankConteudo.senhaOperacional")) {
					let newLabels = utils.deepJsonMerge(labels, res.data.mobileBankConteudo.senhaOperacional);

					if (JSON.stringify(labels) !== JSON.stringify(newLabels)) {
						labels = newLabels;
						localStorage.setItem("lastUpdateLabels", moment(new Date()).format("YYYY-MM-DD"));
						localStorage.setItem("cachedLabels", JSON.stringify(newLabels));
						$rootScope.$emit("labelService:labelsChanged", newLabels);
					}
				}
			});*/
	};

	/**
	 * Return labels by given page
	 */
	const getLabelsByPage = (page) => {
		return labels ? labels[page] : {};
	};

	/**
	 * Return a specific label by page and key
	 */
	const getLabelByPageAndKey = (page, key) => {
		return labels ? labels[page] ? labels[page][key] : "" : "";
	};

	/**
	 * Return a specific label by pageKey expression
	 * E.G: PageKey expression is a string that's looks like: page:key
	 */
	const getLabelByExpression = (pageKeyExpression) => {
		let page, key;

		if (pageKeyExpression && pageKeyExpression.contains(":")) {
			page = pageKeyExpression.substring(0, pageKeyExpression.indexOf(":"));
			key = pageKeyExpression.substring(pageKeyExpression.indexOf(":") + 1);
		}

		return page && key && getLabelByPageAndKey(page, key) ? getLabelByPageAndKey(page, key).titulo : "";
	};

	return {getLabelsByPage, getLabelByPageAndKey, getLabelByExpression, init};
};

export default labelService;


// WEBPACK FOOTER //
// ./src/app/misc/services/label.service.js